<!-- =========================================================================================
  File Name: DataViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <span v-if="userScreen">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4 style="word-break: normal;">{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT"  }} {{ $t('user.title') }} </h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <!-- Product Image -->
        <template >
          <!-- Image Container -->
            <div class="contained-example-container">
            <div id="div-with-loading" class="vs-con-loading__container">
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center vs-con-loading__container" id="div-with-loading">

            <img loading="lazy" v-if="ImgName" :src="dataImg" class="responsive">
          </div>
          </div>
            </div>
          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click.native="$refs.updateImgInput.click()">{{this.ImgName == null ? "Upload" : "Update" }} {{ $t('user.add.image') }}</vs-button>
            <vs-button v-if="ImgName!==null" type="flat" color="#999" @click.native="ImgName = null , dataImg = null">{{ $t('user.add.btn_remove_image') }}</vs-button>
          </div>
        </template>
        <!-- FIRST NAME -->
        <span v-if="dataId">
        <vs-input name="Username" :label="$t('user.add.user_name')" v-model="dataUserName" @input="checkUserNameExcepteId" class="mt-5 w-full" v-validate="'alpha_num|required'" maxlength="50"/>
         <span class="text-danger text-sm" v-show="errors.has('Username')">{{ errors.first('Username') }}</span>
        <span class="text-danger text-sm" v-if="UserDuplicate>0">UserName has  already been taken!</span>
        <!-- <span class="text-danger text-sm" v-show="errors.has($t('user.add.user_name'))">{{ errors.first($t('user.add.user_name')) }}</span>
        <span class="text-danger text-sm" v-if="UserDuplicate>0">{{ $t('user.add.user_name') }} already has been taken!</span>
        <span class="text-danger text-sm" v-if="alphanumeric>0 && dataUserName!=''">Input Shoud be Alpha Numaric</span> -->
        </span>
        <vs-input :label="$t('user.add.first_name')" v-model="dataFirstName" class="mt-5 w-full" name="first name" v-validate="'required'" maxlength="50" />
        <span class="text-danger text-sm" v-show="errors.has('first name')">{{ errors.first('first name') }}</span>
          <!-- Middle NAME -->

        <vs-input v-show="dataId"  :label="$t('user.add.middle_name')" v-model="dataMiddleName" class="mt-5 w-full" name="middle name" maxlength="50" />
        <span  v-if="dataId" class="text-danger text-sm" v-show="errors.has('middle name')">{{ errors.first('middle name') }}</span>


        <!-- LAST NAME -->
        <vs-input :label="$t('user.add.last_name')" v-model="dataLastName" class="mt-5 w-full" name="last name" v-validate="'required'" maxlength="50" />
        <span class="text-danger text-sm" v-show="errors.has('last name')">{{ errors.first('last name') }}</span>

        <!-- EMAIL -->
       <vs-input :label="$t('user.add.email')" autocomplete="off" @input="acceptEmail" v-model="dataEmail" class="mt-5 w-full" :name="$t('user.add.email')" v-validate="'email|required'" maxlength="100" />
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.email'))">{{ errors.first($t('user.add.email')) }}</span>
        <span class="text-danger text-sm" v-if="Duplicate>0">{{$t('user.add.email')}} has already been taken!</span>


        <!-- PHONE -->
        <vs-input :label="$t('user.add.phone_no')" v-model="dataPhone"  @input="acceptNumber" class="mt-5 w-full" :name="$t('user.add.phone_no')" maxlength="50"/>
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.phone_no'))">{{ errors.first($t('user.add.phone_no')) }}</span>
        <span v-if="dataPhone.length > 0 &&  dataPhone.length < 14" class="text-danger text-sm">Invalid phone number format.</span><br>
         <!-- <label>Locations</label><br> <br>
        <vs-checkbox v-for="location in locations" :key="location.id" :vs-value="location.id" v-model="dataLocation">
          {{ location.name }}
        </vs-checkbox> -->
        <label class="vs-select--label w-full">Location</label>
        <v-select  label="name" autocomplete="off" multiple :closeOnSelect="true" v-model="dataLocation" v-on:input="selectLocation" :options="locations"/>
        <!-- Send Invite Email -->
          <br  v-show="enableInvitOption">
        <vs-checkbox  v-show="enableInvitOption" @input="changeInviteEmailStatus(dataEmailInviteOption)" v-model="dataEmailInviteOption">{{ $t('user.add.invite_email') }}</vs-checkbox>
         <div v-if="!dataEmailInviteOption && dataId==null">
                       <!-- Username -->
        <vs-input name="Username" :label="$t('user.add.user_name')" v-model="dataUserName" @input="checkUserName" class="mt-5 w-full" v-validate="'alpha_num|required'" maxlength="50"/>
        <span class="text-danger text-sm" v-show="errors.has('Username')">{{ errors.first('Username') }}</span>
        <span class="text-danger text-sm" v-if="UserDuplicate>0">UserName has  already been taken!</span>

        <!-- <vs-input :label="$t('user.add.user_name')" v-model="dataUserName" @input="checkUserName" class="mt-5 w-full" :name="$t('user.add.user_name')" v-validate="'required'" maxlength="50"/>
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.user_name'))">{{ errors.first($t('user.add.user_name')) }}</span>
        <span class="text-danger text-sm" v-if="UserDuplicate>0">{{ $t('user.add.user_name') }} already has been taken!</span>
        <span class="text-danger text-sm" v-if="alphanumeric>0 && dataUserName!=''">Input Shoud be Alpha Numaric</span> -->
        <br>
        <vx-input-group v-if="dataId==null">
                  <template slot="append">
                    <div class="append-text cursor-pointer" style="color:#B0AFB7;background-color:white;border:1px solid rgba(0, 0, 0, 0.2); border-left:none">
                      <span @click="showPassword = !showPassword">
                              <feather-icon v-if="showPassword" icon="EyeOffIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                              <feather-icon v-else icon="EyeIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                        </span>
                    </div>
                  </template>

                  <vs-input 
                  ref="password"
                  v-model="dataPassword" 
                   data-vv-validate-on="blur"
                   v-validate="'required|min:6|max:20'"
                    v-bind:type="[showPassword ? 'text' : 'password']" 
                    name="password"
                    placeholder="Password"
                    class="w-full no-right-border "
                     maxlength="50"
                     autocomplete="off"
                  />
                </vx-input-group>
                <span class="text-danger text-sm">{{ errors.first('password') }}</span> 

        <vs-input
          v-if="dataId==null"
          type="password"
          v-validate="'min:6|max:20|confirmed:password'"
          data-vv-validate-on="blur"
          data-vv-as="password"
          name="confirm_password"
          label-placeholder="Confirm Password"
          placeholder="Confirm Password"
          v-model="dataConfPassword"
          class="w-full mt-6"
           maxlength="50" />
        <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

        </div>
        <br>
        <vs-row class="mb-5 ml-1" v-if="this.dataId==null">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
        <label >{{ $t('user.add.status') }}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
           <vs-switch v-model="pending"></vs-switch>
        </vs-col>
        </vs-row>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">{{ $t('user.add.btn_submit') }}</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">{{ $t('user.add.btn_cancel') }}</vs-button>
    </div>
    </span>
    <span v-else>
        <div class="mt-6 flex items-center justify-between px-6">        
         <span class="flex items-center" style="word-break: normal;">
          <h6>ADD {{ $t('student.title') }} FOR:</h6> 
        <vs-chip color="primary">
        <vs-avatar v-if="new_Student.dataUserImage" :src="img_cdn+new_Student.dataUserImage"/>
        <vs-avatar v-else />
        <p> {{ new_Student.dataUserFirstName+' '+new_Student.dataUserLastName }}</p>
        </vs-chip>
      </span>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <vs-row>
    <vs-col vs-w="12">
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="flex p-6 pb-0">
          <vs-checkbox v-model="BoxNew">Add New</vs-checkbox>
        </div>
        <br>
      <div class="p-6" v-if="BoxEx">
        <div>
        <label class="vs-select--label w-full">Select Existing {{ $t('student.titlesmall') }}</label>
        <v-select   label="name"   :closeOnSelect="true" v-model="new_Student.student" :options="new_Student.students"   />
        </div>
      </div>
       <div class="p-6" v-else>
        <template >
           <!-- <vs-button @click="openLoadingInDiv" >Div with Loading</vs-button> -->

            <div class="contained-example-container">
            <div id="div-with-loading" class="vs-con-loading__container">
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center vs-con-loading__container" id="div-with-loading">
            <img v-if="new_Student.ImgName" :src="new_Student.dataImg" class="responsive">
          </div>
          </div>
            </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateStudentCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click.native="$refs.updateImgInput.click()">{{this.new_Student.ImgName == null ? "Upload" : "Update" }} {{$t('student.add.image')}}</vs-button>
            <vs-button v-if="new_Student.ImgName!==null" type="flat" color="#999" @click.native="new_Student.ImgName = null , new_Student.dataImg = null">{{$t('student.add.btn_remove_image')}}</vs-button>
          </div>
        </template>
        <!-- NAME -->
        <vs-input v-if="lng!='dogs'" label="First Name *" v-model="new_Student.dataFirstName" class="mt-5 w-full" :name="$t('student.add.first_name')" v-validate="'required'" maxlength="50"/>
        <vs-input v-else :label="$t('student.add.first_name')" v-model="new_Student.dataFirstName" class="mt-5 w-full" :name="$t('student.add.first_name')" v-validate="'required'" maxlength="50"/>
        <span class="text-danger text-sm" v-show="errors.has($t('student.add.first_name'))">{{ errors.first($t('student.add.first_name')) }}</span>

        <vs-input v-if="lng!='dogs'" :label="$t('student.add.middle_name')"  v-model="new_Student.dataMiddleName" class="mt-5 w-full" :name="$t('student.add.middle_name')"  maxlength="50" />

        <vs-input v-if="lng!='dogs'" :label="$t('student.add.last_name')" v-model="new_Student.dataLastName" class="mt-5 w-full" :name="$t('student.add.last_name')" v-validate="'required'" maxlength="50" />
        <span class="text-danger text-sm" v-show="errors.has($t('student.add.last_name'))">{{ errors.first($t('student.add.last_name')) }}</span>
         <!-- NICk Name -->
        <vs-input v-if="lng!='dogs'" :label="$t('student.add.nick_name')"  v-model="new_Student.dataNick" class="mt-5 w-full" :name="$t('student.add.nick_name')" maxlength="50" /><br>
        <!-- <span class="text-danger text-sm" v-show="errors.has('Nick Name')">{{ errors.first('Nick Name') }}</span><br> -->
        <!-- CATEGORY -->
        <label class="vs-select--label w-full">{{$t('student.add.dob')}}</label>
      <vs-row>
  <vs-col  vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
    <datepicker class="w-full"  v-model="new_Student.dataBirthday" format="MM/dd/yyyy"  :minimumView="'day'" :maximumView="'year'" :initialView="'month'"></datepicker><span v-if="new_Student.dataBirthday" class="mb-8 ml-1"  @click="new_Student.dataBirthday = null">x</span>

  </vs-col>
  <!-- <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
   </vs-col> -->
</vs-row><br>
        <label class="vs-select--label w-full">{{$t('student.add.location')}}</label>
        <v-select  label="name" :closeOnSelect="true" v-model="new_Student.dataLocation" v-on:input="selectStudentLocation" :options="new_Student.UserLocations"/><br>
        <!-- <ul class="centerx mt-2  flex flex-wrap">
         <li class="ml-1" v-for="location in new_Student.UserLocations" :key="location.id">
         <vs-radio v-model="new_Student.dataLocation" @change="getLocation(location,'new')" :vs-value="location.id">{{location.name}}</vs-radio>
        </li>
        </ul> -->
        <label class="vs-select--label w-full">{{$t('student.add.program')}}</label>
        <v-select  label="name"   :closeOnSelect="true" v-model="new_Student.dataProgram"  :options="new_Student.programs"  /><br>

        <!-- ORDER STATUS -->

        <label class="vs-select--label w-full">{{$t('student.add.cameras')}}</label>
        <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer ml-4 " v-if="new_Student.groups && new_Student.groups.length>0">
        <a class="flex items-center" style="font-size: .85rem;">
           Copy from group 
          <i class="material-icons">expand_more</i>
        </a>

        <vs-dropdown-menu style="z-index:9999999;">

          <vs-dropdown-item v-for="group in new_Student.groups" :key=group.id @click="getGroupCamera(group)">
            {{group.name}}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
        <v-select  label="name"  multiple :closeOnSelect="true" v-model="new_Student.dataCamera"  :options="new_Student.cameras"/><br>

        <!-- STATUS -->
        <vs-row vs-w="12" class="ml-6">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="2" vs-xs="1">
            <label>Status</label>
          </vs-col>  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="9">
        </vs-col>  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="1">
          <vs-switch v-model="new_Student.dataStatus"></vs-switch>
        </vs-col>
        </vs-row>

      </div>
    </component>
     </vs-col>
    </vs-row>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">{{ $t('user.add.btn_submit') }}</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">{{ $t('user.add.btn_cancel') }}</vs-button>
    </div>
    </span>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import {GET_ALL_LOCATIONS, CREATE_INVITE_USER, SINGLE_USER_BY_EMAIL, SINGLE_USER_BY_USERNAME, UPDATE_USER, UPLOAD_IMAGE, CREATE_USER_ACTIVITY, UPDATE_USER_ACTIVITY, MANAGER_LOCATION, CHECK_USER_EMAIL,
GET_USER_LOCATION_STUDENTS ,
ADD_USER_STUDENT,
GET_CAMERA_BY_LOCATION, 
GET_PROGRAM_BY_LOCATION,
CREATE_STUDENT,
CHECK_USER_NAME_EXCEPT_ID,
GET_GROUPS_BY_LOCATION,
GET_GROUP_CAMERAS
} from '@/graphql'
import S3 from 'aws-s3'
const config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url,
  dirName: process.env.VUE_APP_AWS_DIREC+'/UserImage',
}
const stu_config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url,
  dirName: process.env.VUE_APP_AWS_DIREC+'/StudentImage',
}
const S3Client = new S3(config)
const S3ClientStudent = new S3(stu_config)

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true

    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
     Datepicker,
     moment
  },
  data () {
    return {
      enableBtn:true,
      userScreen:true,
      img_cdn:process.env.VUE_APP_AWS_s3Url+"/",
      locations:[],
      Duplicate:0,
      UserDuplicate:0,
      alphanumeric:0,
      enableInvitOption:true,
      dataId: null,
      dataUserName: '',
      dataFirstName: '',
      dataMiddleName: '',
      dataLastName: '',
      dataImg:null,
      ImgName:null,
      dataImgUrl:'',
      dataEmail: '',
      dataPhone: '',
      dataPassword:'',
      dataConfPassword:'',
      dataEmergencyContact: false,
      dataStudent: '',
      dataStatus: true,
      dataEmailInviteOption:true,
      isEmailConfirmed: true,
      dataLocation:[],
      pending:false,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      new_Student:{
      dataUserId:'',
      dataUserFirstName:'',
      dataUserLastName:'',
      dataUserImage:'',  
      students:[],
      student:null,
      locations:[],
      UserLocations:[],
      ImgName:null,
      camusers:[],
      cameras:[],
      programs:[],
      dataId: null,
      dataFirstName: '',
      dataMiddleName: '',
      dataLastName: '',
      dataProgram: [],
      dataCamUser: [],
      dataCamera:[],
      dataLocation:'',
      dataImg: null,
      dataNick:'',
      dataStatus:true,
      dataBirthday:'',
      groups:[],
      dataGroup:[],
      },
      BoxEx:true,
      BoxNew:false,
      lng:'',
      showPassword:false,
    }
  },
  watch: {
    isSidebarActive (val) {
      this.userScreen = true
      if(val){
        this.BoxEx=true
      }
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
        this.enableInvitOption = true
      } else {
        const { id, username, fname, lname, middle_name, status, email, phone, students, avatar, emergency_contact, email_confirmed, pending, locations } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataUserName = username
        this.dataFirstName = fname
        this.dataMiddleName = middle_name
        this.dataLastName = lname
        this.dataImg = this.img_cdn + avatar
        this.ImgName = avatar
        this.dataEmail = email
        this.dataPhone = phone
        if (!this.dataPhone) {
          this.dataPhone = ''
        }
        this.dataLocation = locations
        // this.dataLocation = locations.map(function (value, index) {
        //   return value.id;
        // });
        this.dataEmergencyContact = emergency_contact
        this.dataStudent = students
        this.dataStatus = status
        this.pending = pending
        this.isEmailConfirmed = email_confirmed
        this.enableInvitOption = false
        this.initValues()
      }
    },
      BoxNew(val){
        this.BoxEx=!val
        if(val){
          this.resetStudent()
        }
      }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      if(this.userScreen){
      if (this.dataEmailInviteOption && this.dataId == null) {
        return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataEmail && this.Duplicate === 0 && this.UserDuplicate === 0 && (this.dataPhone == '' || this.dataPhone.length == 14) && this.enableBtn
      }
      if (!this.dataEmailInviteOption && this.dataId == null) {
        return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataPassword && this.dataConfPassword && this.dataEmail && this.Duplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0 && (this.dataPhone == '' || this.dataPhone.length == 14) && this.enableBtn
      }
      if (this.dataEmailInviteOption && this.dataId) {
        return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataEmail && this.Duplicate === 0 && this.UserDuplicate === 0 && (this.dataPhone == '' || this.dataPhone.length == 14) && this.enableBtn
      }
       if (!this.dataEmailInviteOption && this.dataId) {
        return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataEmail && this.Duplicate === 0 && this.UserDuplicate === 0 && (this.dataPhone == '' || this.dataPhone.length == 14) && this.enableBtn
      }
    }
    else{
      if(this.BoxEx){
          return !this.errors.any() && this.new_Student.student && this.enableBtn
      }
      else{
       if (this.lng == 'dogs') {
        this.new_Student.dataLastName = 'pet'
      }
      return !this.errors.any() && this.new_Student.dataProgram != '' && this.new_Student.dataFirstName && this.new_Student.dataLastName && this.new_Student.dataLocation && this.enableBtn
    }
    }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    selectStudentLocation(event){
     if(event){
         if(!event.billing){
            this.$vs.notify({
            title: 'Error',
            text: 'This record is disabled because of its locations’ billing problems.',
            color: 'danger',
            position: 'top-right'
          })
           this.new_Student.dataLocation='';
         }
         else{
            this.getLocation(event,'new');
         }
      }
      else{
        this.new_Student.dataCamera = []
        this.new_Student.dataProgram = []
        this.new_Student.dataGroup = []
      }
    },
    selectLocation(event){
      if(event.length>0){
       if(!event[event.length - 1].billing){
        this.$vs.notify({
        title: 'Error',
        text: 'This record is disabled because of its locations’ billing problems.',
        color: 'danger',
        position: 'top-right'
      })
      for (let i = 0; i < this.dataLocation.length; i++) { 
        if (this.dataLocation[i].id == event[event.length - 1].id) { 
          this.dataLocation.splice(i, 1) 
        }
      }
      }
      }
    },
    // changeEmailConfirmationStatus(val) {
    //   this.pending = !val
    // },
    changeInviteEmailStatus (val) {
      this.pending = !val
    },
    openLoadingInDiv () {
      this.$vs.loading({
        type:'sound',
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    StatusSuccess () {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: 'Added successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
     StudentStatusSuccess () {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: 'Added successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
    StatusFail () {
      this.$vs.notify({
        title:this.$t('user.alert_title'),
        text: 'Failed to add!',
        color: 'danger',
        position: 'top-right'
      })
    },
    UpdateSuccess () {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: 'Updated successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
    UpdateFail () {
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: 'Failed to Update!',
        color: 'danger',
        position: 'top-right'
      })
    },
    acceptEmail () {
      if (this.dataId !== null && this.dataId >= 0) {
        this.checkEmailExceptId()
      } else {
        this.checkEmailWithoutId()
      }
    },
    checkEmailExceptId () {
      this.$apollo
        .mutate({
          mutation: CHECK_USER_EMAIL,
          variables: {
            id: this.dataId,
            email: this.dataEmail
          }
        })
        .then(response => {
          this.Duplicate = response.data.checkUserEmail.length
        })
    },
    checkEmailWithoutId () {
      this.$apollo
        .mutate({
          mutation: SINGLE_USER_BY_EMAIL,
          variables: {
            email: this.dataEmail
          }
        })
        .then(response => {
          this.Duplicate = response.data.userByEmail.length
        })
    },
    checkUserName () {
    if (this.dataUserName.length>0){
        this.$apollo
          .mutate({
            mutation: SINGLE_USER_BY_USERNAME,
            variables: {
              username: this.dataUserName
            }
          })
          .then(response => {
            this.UserDuplicate = response.data.userByUserName.length
          })
      }
      else{
        this.dataUserName=''
        this.UserDuplicate = 0
      }
    },
   checkUserNameExcepteId(){
      if(this.dataUserName.length>0){
        this.$apollo
          .mutate({
            mutation: CHECK_USER_NAME_EXCEPT_ID,
            variables: {
              id: this.dataId,
              username: this.dataUserName
            }
          })
          .then(response => {
            this.UserDuplicate = response.data.checkUserNameExceptId.length
          })
      }
      else{
        this.dataUserName=''
        this.UserDuplicate = 0
      }
   },
    acceptNumber () {
      const x = this.dataPhone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

      this.dataPhone = !x[2]
        ? x[1]
        : `(${  x[1]  }) ${  x[2]  }${x[3] ? `-${  x[3]}` : ''}`
    },
    initValues () {
      this.enableBtn=true
      if (this.data.id) return
      this.dataId = null
      this.dataFirstName = ''
      this.dataLastName = ''
      this.dataUserName = ''
      this.dataMiddleName = ''
      this.dataImg = null
      this.ImgName = null
      this.dataStudent = ''
      this.dataStatus = true
      this.dataEmergencyContact = false
      this.dataEmailInviteOption = true
      this.pending = false
      this.dataEmail = ''
      this.dataPhone = ''
      this.dataPassword = '',
      this.dataConfPassword = '',
      this.dataLocation = []
      this.BoxEx=true
      this.BoxNew=false
      this.userScreen=true
    },
    initValuesStu(){
      this.enableBtn=true
      this.new_Student.dataUserId='',
      this.new_Student.dataUserFirstName='',
      this.new_Student.dataUserLastName='',
      this.new_Student.dataUserImage='',  
      this.new_Student.students=[],
      this.new_Student.student=null,
      this.new_Student.locations=[],
      this.new_Student.UserLocations=[],
      this.new_Student.ImgName=null,
      this.new_Student.camusers=[],
      this.new_Student.cameras=[],
      this.new_Student.programs=[],
      this.new_Student.dataId=null,
      this.new_Student.dataFirstName='',
      this.new_Student.dataMiddleName='',
      this.new_Student.dataLastName='',
      this.new_Student.dataProgram=[],
      this.new_Student.dataCamUser=[],
      this.new_Student.dataCamera=[],
      this.new_Student.dataLocation='',
      this.new_Student.dataImg=null,
      this.new_Student.dataNick='',
      this.new_Student.dataStatus=true,
      this.new_Student.dataBirthday=''
      this.new_Student.dataGroup=[]
      this.new_Student.groups=[]
      this.userScreen=false
      this.BoxEx=true
      this.BoxNew=false
    },
    resetStudent(){
      this.new_Student.ImgName=null,
      this.new_Student.dataId=null,
      this.new_Student.dataFirstName='',
      this.new_Student.dataMiddleName='',
      this.new_Student.dataLastName='',
      this.new_Student.dataProgram=[],
      this.new_Student.dataCamera=[],
      this.new_Student.dataLocation='',
      this.new_Student.dataImg=null,
      this.new_Student.dataNick='',
      this.new_Student.dataStatus=true,
      this.new_Student.dataBirthday=''
    },
    submitData () {
      if(this.userScreen){
      const getlocationids = []
      for (let j = 0; j < this.dataLocation.length; j++) {
        getlocationids.push(this.dataLocation[j].id)        
      }
      // this.dataLocation=getlocationids
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.enableBtn=false
            this.$apollo
              .mutate({
                mutation: UPDATE_USER,
                variables: {
                  id: this.dataId,
                  fname: this.dataFirstName,
                  middle_name: this.dataMiddleName,
                  lname: this.dataLastName,
                  username: this.dataUserName,
                  phone: this.dataPhone,
                  locations:getlocationids,
                  email: this.dataEmail,
                  email_confirmed: this.isEmailConfirmed,
                  status: this.dataStatus,
                  emergency_contact:this.dataEmergencyContact,
                  avatar: this.ImgName,
                  pending:this.pending
                }
              })
              .then(response => {
                if (response.data.updateUser.status == 'SUCCESS') {
                   this.enableBtn=true
                  this.$emit('closeSidebar')
                  this.UpdateSuccess()
                  this.userActivity(this.dataId,"updated")

                }
              }).catch(error => {
                console.log(error)
                 this.enableBtn=true
              })

          } else {
            if (this.dataEmailInviteOption) {
              this.dataUserName = 'User'
            }
            this.enableBtn=false
            this.$apollo
              .mutate({
                mutation: CREATE_INVITE_USER,
                variables: {
                  fname: this.dataFirstName,
                  middle_name: this.dataMiddleName,
                  lname: this.dataLastName,
                  username: this.dataUserName,
                  phone: this.dataPhone,
                  locations: getlocationids,
                  email: this.dataEmail,
                  email_confirmed: this.isEmailConfirmed,
                  status: this.dataStatus,
                  emergency_contact: this.dataEmergencyContact,
                  pending: !this.pending,
                  invite_email: this.dataEmailInviteOption,
                  avatar: this.ImgName,
                  password: this.dataPassword,
                  roles: ['6']
                }
              })
              .then(response => {
                if (response.data.createInviteUser.status = 'SUCCESS') {
                   this.enableBtn=true
                  // console.log(response.data.createInviteUser.user)
                  this.userActivity(response.data.createInviteUser.user.id,"added")
                  var user = response.data.createInviteUser.user
                  // console.log(response.data.createInviteUser.user)
                  this.StatusSuccess()
                  this.userScreen=false
                  if(user.locations.length > 0){
                      this.new_Student.UserLocations = user.locations
                  }
                  else{
                      this.LocationforStudent()
                  }
                  this.new_Student.dataUserId = user.id
                  this.new_Student.dataUserFirstName = user.fname
                  this.new_Student.dataUserLastName = user.lname
                  this.new_Student.dataUserImage = user.avatar
                  const locations_id = []
                  for (let index = 0; index < user.locations.length; index++) {
                    locations_id.push(user.locations[index].id)
                  }
                  if (locations_id.length > 0) {
                    this.getUserLocationsStudent(locations_id, user.id)
                  }
                  // this.$emit('closeSidebar')
                  this.dataPassword = ''
                  this.dataConfPassword = '' 
                }
              }).catch(error => {
                this.StatusFail()
                console.log(error)
                this.enableBtn=true
              })
          }
        }
      })
    }
    else{
      this.$validator.validateAll().then(result => {
        if (result) {
        if(this.BoxEx){
          this.enableBtn=false
          this.$apollo
            .mutate({
              mutation: ADD_USER_STUDENT,
              variables: {
                student:this.new_Student.student.id,
                user: this.new_Student.dataUserId
              }
            })
            .then(response => {
              if (response) {
                this.StudentStatusSuccess()
                 this.enableBtn=true
                this.$emit('closeSidebar')
                this.initValuesStu()
              }
            }).catch(error => {
              this.StatusFail()
              console.log(error)
               this.enableBtn=true
            })
        }
        if(this.BoxNew){
            this.new_Student.dataCamUser = [this.new_Student.dataUserId]
            const getcamerasids = []
            for (let j = 0; j < this.new_Student.dataCamera.length; j++) {
              const getcameraid = this.new_Student.dataCamera[j].id
              getcamerasids.push(getcameraid)
            }
           if (this.new_Student.dataBirthday) {
              this.new_Student.dataBirthday = moment(this.new_Student.dataBirthday).format('YYYY-MM-DD')
            }
           this.enableBtn=false
           this.$apollo
              .mutate({
                mutation: CREATE_STUDENT,
                variables: {
                  fname:this.new_Student.dataFirstName,
                  middle_name:this.new_Student.dataMiddleName,
                  lname: this.new_Student.dataLastName,
                  nick_name: this.new_Student.dataNick,
                  dob:this.new_Student.dataBirthday,
                  image:this.new_Student.ImgName,
                  status: this.new_Student.dataStatus,
                  location_id: this.new_Student.dataLocation.id,
                  program_id: this.new_Student.dataProgram.id,
                  cameras: getcamerasids,
                  users: this.new_Student.dataCamUser
                }
              })
              .then(response => {
                if (response) {
                  if (response.data.createStudent.status === 'Success') {
                    this.enableBtn=true
                    this.StudentStatusSuccess()
                    this.$emit('closeSidebar')
                    this.initValuesStu()
                    this.initValues()
                    this.userActivityStu(response.data.createStudent.id)
                  } else {
                    this.LocationLimitFail()
                  }
                }

              }).catch(error => {
                this.StatusFail()
                 this.enableBtn=true
                console.log(error)
              })
        }
        }
      }
      )
    }
    },
      LocationLimitFail () {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: 'Cannot Exceed Location Limit. Failed to add!',
        color: 'danger',
        position: 'top-right'
      })
    },
    userActivityStu ($id) {
      this.$apollo
        .mutate({
          mutation: CREATE_USER_ACTIVITY,
          variables: {
            object_id: $id,
            object_type:'App\\Models\\Student',
            activity:'added'
          }
        })
    },
     updateCurrImg (input) {
          const file = input.target.files[0]
          const name = Math.random().toString().slice(2)
          this.openLoadingInDiv()
          S3Client.uploadFile(file, name)
            .then(response => {
              this.ImgName = response.key
              this.dataImg = this.img_cdn+response.key
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            })
            .catch(err => console.error(err))
      },
      updateStudentCurrImg (input) {
          const file = input.target.files[0]
          const name = Math.random().toString().slice(2)
          this.openLoadingInDiv()
          S3ClientStudent.uploadFile(file, name)
            .then(response => {
              this.new_Student.ImgName = response.key
              this.new_Student.dataImg = this.img_cdn+response.key
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            })
            .catch(err => console.error(err))
      },
    // updateCurrImg (input) {
    //   if (input.target.files && input.target.files[0]) {
    //     this.checkImg = 'somthing'
    //     const reader = new FileReader()
    //     reader.onload = e => {
    //       this.dataImg = e.target.result
    //       this.openLoadingInDiv()
    //       this.$apollo
    //         .mutate({
    //           mutation: UPLOAD_IMAGE,
    //           variables: {
    //             image:this.dataImg,
    //             oldimage:this.oldimage
    //           }
    //         })
    //         .then(response => {
    //           if (response) {
    //             this.oldimage = ''
    //             if (response.data.uploadImage.status == 'SUCCESS') {
    //               this.ImgName = response.data.uploadImage.image_name
    //               this.$vs.loading.close('#div-with-loading > .con-vs-loading')
    //             } else {
    //               this.ImgName = response.data.uploadImage.image_name
    //               this.UploadFail(response.data.uploadImage.error)
    //               this.$vs.loading.close('#div-with-loading > .con-vs-loading')
    //             }

    //           }
    //         }).catch(error => {
    //           console.log(error)
    //         })
    //     }
    //     reader.readAsDataURL(input.target.files[0])
    //   }
    // },
    LocationforStudent() {
      let userId= localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name
      this.conditionMethod(userRole,userId,"student")
    },
    get () {
      let userId= localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name
      this.conditionMethod(userRole,userId,"user")
    },
    conditionMethod (role, id ,isfor) {
      if (role == 'manager') {
        this.$apollo
        .mutate({
          mutation: MANAGER_LOCATION,
          variables: {
            id: id
          }
        })
        .then(response => {
          if(isfor==='user'){
              this.locations = response.data.user.managerlocations
          }
          else{
             this.new_Student.UserLocations=response.data.user.managerlocations
          }
        })
      } else {
        this.getAllLocation(isfor)

      }
    },
    getAllLocation (isfor) {
      this.$apollo
        .mutate({
          mutation: GET_ALL_LOCATIONS
        })
        .then(response => {
          console.log(response)
          if(isfor==='user'){
            this.locations = response.data.getAllLocations
          }
          else{
            this.new_Student.UserLocations=response.data.getAllLocations
          }
        })
    },
     getUserLocationsStudent (locations, user) {
      this.$apollo
        .mutate({
          mutation: GET_USER_LOCATION_STUDENTS,
          variables: {
            locations,
            user_id:user
          }
        })
        .then(response => {
          const students = []
          for (let i = 0; i < response.data.user_locations_student.length; i++) {
            if(response.data.user_locations_student[i].status){
            if (response.data.user_locations_student[i].middle_name) {
              response.data.user_locations_student[i].name = `${response.data.user_locations_student[i].fname} ${response.data.user_locations_student[i].middle_name}  ${response.data.user_locations_student[i].lname}`
            } else {
              response.data.user_locations_student[i].name = `${response.data.user_locations_student[i].fname} ${response.data.user_locations_student[i].lname}`
            }
            students.push(response.data.user_locations_student[i])
          }
          } 

          this.new_Student.students = students

          //  this.students=response.data.user_locations_student
        }).catch(error => {

          console.log(error)

        })
    },
    getLocation (location, msg) {
    if(location.billing){
      this.$apollo
        .mutate({
          mutation: GET_CAMERA_BY_LOCATION,
          variables: {
            location_id:location.id
          }
        })
        .then(response => {
          if (response) {
            this.new_Student.cameras = response.data.location_cameras
            if (msg == 'new') {
              this.new_Student.dataCamera = []
            }
          }
        }).catch(error => {
          console.log(error)
        })
      this.$apollo
        .mutate({
          mutation: GET_PROGRAM_BY_LOCATION,
          variables: {
            location_id:location.id
          }
        })
        .then(response => {
          if (response) {
            this.new_Student.programs = response.data.location_programs
            if (msg == 'new') {
              this.new_Student.dataProgram = []
            }
          }
        }).catch(error => {
          console.log(error)
        })
         this.$apollo
        .mutate({
          mutation: GET_GROUPS_BY_LOCATION,
          variables: {
            location_id:location.id
          }
        })
        .then(response => {
          if (response) {
            console.log(response)
            this.new_Student.groups = response.data.location_groups
            if (msg == 'new') {
              this.new_Student.dataGroup = []
            }
          }
        }).catch(error => {
          console.log(error)
        })
      }
      else{
        this.$vs.notify({
        title: 'Error',
        text: 'This record is disabled because of its locations’ billing problems.',
        color: 'danger',
        position: 'top-right'
      })
      this.new_Student.dataLocation=''
      }
    },
     getGroupCamera(group){
      if(group.id){
        this.$apollo
        .mutate({
          mutation: GET_GROUP_CAMERAS,
          variables: {
            group_id:group.id
          }
        })
        .then(response => {
          if (response) {
            var cameras= response.data.getGroupCameras;
            for (let index = 0; index < cameras.length; index++) {
              this.new_Student.dataCamera.push(cameras[index])
            }
             this.new_Student.dataCamera=this.new_Student.dataCamera.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
  userActivity (id,action) {
      this.$apollo
        .mutate({
          mutation: CREATE_USER_ACTIVITY,
          variables: {
            object_id: id,
            object_type:'App\\Models\\User',
            activity:action
          }
        })
    },
  },
  created () {
    this.lng = process.env.VUE_APP_I18N_LOCALE
    this.get()

  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
